<template>
  <div>
    <h3 class="heading-3 mt-8">{{ i18n(translations.title) }}</h3>
    <p class="body-1 mt-16">
      {{ i18n(translations.description) }}
    </p>
    <RevForm
      :id="formId"
      class="mt-32"
      :initial-values
      :validate
      @submit="handleSubmit"
    >
      <template #default="{ values, errors }">
        <RevRadio
          v-for="action in actions"
          :id="action.id"
          :key="action.id"
          v-model="values.selectedAction"
          class="mt-16 last-of-type:mb-16"
          :data-qa="action.id"
          :value="action.id"
          variant="full"
        >
          <template #label> {{ action.title }}</template>
          <template #description> {{ action.description }}</template>
        </RevRadio>

        <p v-if="errors.selectedAction" class="text-static-danger-hi body-2">
          {{ errors.selectedAction }}
        </p>
      </template>
    </RevForm>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { BuybackOrderDetailsOnHoldAction } from '@backmarket/http-api/src/api-specs-buyback/seller/refurbisher.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { FORM_VALID, RevForm, makeValidate } from '@ds/components/Form'
import { RevRadio } from '@ds/components/Radio'

import { ON_HOLD_STEPS } from '../../constants'

import translations from './IntroView.translations'

defineProps<{
  actions: BuybackOrderDetailsOnHoldAction[]
}>()

const emit = defineEmits<{
  (e: 'next', payload: { step: string }): void
}>()

const i18n = useI18n()

const initialValues = ref<{
  selectedAction: string | boolean
}>({
  selectedAction: false,
})

const formId = ON_HOLD_STEPS.INTRO

const validate = computed(() => {
  return makeValidate<typeof initialValues.value>({
    selectedAction: [
      (value) => (value ? FORM_VALID : i18n(translations.requiredErrorMessage)),
    ],
  })
})

const handleSubmit = (value: { selectedAction: string | boolean }) => {
  const step = value.selectedAction
  if (typeof step === 'string') {
    emit('next', { step })
  }
}
</script>
